<template>
  <a-row :gutter="{xs:0, lg:8}">
    <a-col :xs="24" :lg="8">
      <a-card>
        <span class="m-text-title" slot="title">Filter</span>
        <div class="d-flex flex-column">
          <a-input-search v-model="search" placeholder="Pencarian ... " />
          <a-collapse activeKey="1" class="m-top">
            <a-collapse-panel key="1">
              <span slot="header">Cari Lebih Lengkap</span>
              <div class="m-form-item-wrapper">
                <label for="tanggalTransaksi">Tanggal Transaksi</label>
                <a-date-picker v-model="transactionDt" :format="getDefaultDateFormat" allowClear />
              </div>
              <div class="m-form-item-wrapper">
                <label for="tanggalTransaksi">Status</label>
                <a-select
                  placeholder="Ex: Approved ... "
                  v-model="status"
                  class="w-full"
                  initialValue="delivered"
                  allowClear
                >
                  <a-select-option value="delivered">Delivered</a-select-option>
                  <a-select-option value="approved">Approved</a-select-option>
                  <a-select-option value="on process">On Process</a-select-option>
                  <a-select-option value="revised">Revised</a-select-option>
                  <a-select-option value="rejected">Rejected</a-select-option>
                </a-select>
              </div>
            </a-collapse-panel>
          </a-collapse>
        </div>
      </a-card>
    </a-col>
    <a-col :xs="24" :lg="16">
      <H-Datalist
        title="Daftar Permohonan Cuti"
        :manifestLink="manifestFor"
        editLink="edit"
        :dataList="basedData"
        :isSpecialMenu="true"
        :isLoading="isLoading"
        :readable="true"
      >
        <div slot="action-button">
          <!-- <a-button type="primary" @click="handleCreate('Create')">
            <a-icon type="plus" />&nbsp;Permohonan Cuti
          </a-button> -->
        </div>
        <template slot="change-button" slot-scope="{item}">
          <a-button type="danger" @click="handleCreate(item)">
            <a-icon type="edit" />&nbsp; Ubah Data
          </a-button>
        </template>
      </H-Datalist>
    </a-col>

    <a-modal title="Buat Permohonan Cuti" :visible="visible" @cancel="handleCancel">
      <template slot="footer">
        <a-button key="back" @click="handleCancel">Return</a-button>
        <a-button
          key="submit"
          :disabled="disable"
          type="primary"
          :loading="loading"
          @click="handleOk"
        >Submit</a-button>
      </template>
      <a-form class="m-form" :form="form">
        <a-form-item label="Sisa Cuti">
          <a-input disabled v-decorator="['sisa_cuti', {initialValue: initialData.sisaCuti}]" />
        </a-form-item>
        <a-form-item label="Tanggal Cuti">
          <vc-date-picker
            locale="id"
            :min-date="limaHari(mode === 'Create' ? new Date() : new Date(rubahData.data.tgl_buat), 5)"
            :disabled-dates="{ weekdays: [1, 7] }"
            :select-attribute="selectAttribute"
            v-model="dates"
            mode="multiple"
            color="green"
            is-inline
            is-expanded
          />
        </a-form-item>
        <a-form-item label="Keperluan">
          <a-input v-decorator="['keperluan', {initialValue: initialData.keperluan}]" />
        </a-form-item>
        <a-form-item label="Approval">
          <a-select
            :disabled="mode === 'Edit' ? true : false"
            v-decorator="['approval', {
        initialValue: initialData.approval}]"
          >
            <a-select-option
              v-for="item in getCuti.approval"
              :key="item.tlc"
            >{{item.tlc + ' - ' + item.nama}}</a-select-option>
          </a-select>
        </a-form-item>
      </a-form>
    </a-modal>
  </a-row>
</template>

<script>
import axios from "axios";
import { mapGetters, mapActions } from "vuex";
import DataList from "@/components/Datalist";
import moment from "moment";
import _ from "lodash";

export default {
  components: {
    "H-Datalist": DataList
  },
  name: "MonitoringCuti",
  props: ["id_menu", "spesialFor"],
  data() {
    return {
      cutiList: [],
      basedList: [],
      workingDay: [1, 2, 3, 4, 5],
      visible: false,
      transactionDt: null,
      search: "",
      status: "",
      dates: [],
      loading: false,
      disable: false,
      mode: "Create",
      rubahData: {},
      selectAttribute: {
        dot: true
      },
      id_cuti: "",
      isLoading: false
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
  created() {
    this.fetchData();
    this.FETCH_CUTI(this.getAuth.username);
  },
  watch: {
    dates() {
      if (this.mode === "Create") {
        if (this.dates.length > this.getCuti.sisa_cuti) {
          this.$notification.warning({
            message: "Error",
            description:
              "Permintaan Cuti Melebihi Batas Cuti Tahunan!"
          });
          this.disable = true;
        } else {
          this.disable = false;
        }
      } else {
        this.disable = false;
      }
    }
  },
  computed: {
    ...mapGetters([
      "getAuth",
      "getCuti",
      "getDefaultDateFormat",
      "getStandartFormatDate"
    ]),
    basedData() {
      let output = [];

      this.searching.forEach(data => {
        let isRead = 0;
        if (data.need_approve == 1) {
          isRead = 0;
        } else {
          isRead = 1;
        }
        output.push({
          title: data.no_cuti,
          subdesc: [
            [
              { label: "Tanggal Cuti ", value: data.tanggal_cuti },
              { label: "Cuti yang diambil ", value: data.cuti_diambil },
              { label: "Keperluan ", value: data.keperluan }
            ]
          ],
          //status: data.status,
          id: data.id_cuti,
          isRead: isRead,
          timeline: JSON.parse(data.status_app),
        });
      });

      return output;
    },
    manifestFor() {
      let data = "";
      if (this.spesialFor === "Direktur") {
        data = "dir.mon.manifest.cuti";
      } else if (this.spesialFor === "Atasan Langsung") {
        data = "al.mon.manifest.cuti";
      } else if (this.spesialFor === "HRD") {
        data = "hrd.mon.manifest.cuti";
      }
      return data;
    },
    initialData() {
      if (this.mode === "Create") {
        return {
          sisaCuti: this.getCuti.sisa_cuti,
          tanggal_cuti: moment(this.limaHari(moment(), 6)).format(
            this.getDefaultDateFormat
          ),
          keperluan: ""
        };
      } else {
        return {
          sisaCuti: this.getCuti.sisa_cuti,
          keperluan: this.rubahData.data.keperluan,
          approval: this.rubahData.data.approval
        };
      }
    },
    searching() {
      let data = this.cutiList;

      if (this.search) {
        data = _.filter(
          data,
          obj =>
            obj.no_cuti.toLowerCase().indexOf(this.search.toLowerCase()) >= 0 ||
            obj.tgl_buat.toLowerCase().indexOf(this.search.toLowerCase()) >=
              0 ||
            obj.tgl_cuti.toLowerCase().indexOf(this.search.toLowerCase()) >=
              0 ||
            obj.status.toLowerCase().indexOf(this.search.toLowerCase()) >= 0 ||
            obj.keperluan.toLowerCase().indexOf(this.search.toLowerCase()) >= 0
        );
      }

      if (this.status) {
        data = _.filter(
          data,
          obj =>
            obj.status &&
            obj.status.toLowerCase().indexOf(this.status.toLowerCase()) >= 0
        );
      }

      if (this.transactionDt) {
        let searchDate = moment(this.transactionDt).format(
          this.getStandartFormatDate
        );
        data = _.filter(data, { tgl_buat: searchDate });
      }

      return data;
    }
  },
  methods: {
    moment,
    ...mapActions({ FETCH_CUTI: "FETCH_CUTI_DETAIL" }),
    async fetchData() {
      this.isLoading = true;
      await axios({
        method: "get",
        url: this.$serviceUrl + "monitoring/cuti",
        params: {
          tlc: this.getAuth.username,
          id: localStorage.getItem('mns_')
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey
        }
      })
        .then(response => {
          this.cutiList = response.data.data;
          this.isLoading = false;
        })
        .catch(err => {
          this.isLoading = false;
          return err;
        });
    },
    fetchDetilCuti(value) {
      this.id_cuti = value;
      axios({
        method: "get",
        url: this.$serviceUrl + "cuti/detil_cuti",
        params: {
          tlc: this.getAuth.username,
          id_cuti: value
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey
        }
      })
        .then(response => {
          this.rubahData = {
            data: response.data.data[0],
            cuti_split: response.data.data[0].tgl_cuti.split(",")
          };
          this.rubahData.cuti_split.forEach(date => {
            let convertDate = new Date(date);
            let withoutTime = convertDate.setHours(0, 0, 0, 0);
            this.dates = [...this.dates, new Date(withoutTime)];
          });
          this.visible = true;
        })
        .catch(err => {
          return err;
        });
    },

    handleOk() {
      this.form.validateFields((err, values) => {
        this.loading = true;
        let post = new FormData();

        let formatDate = [];
        let formEdit = [];
        for (let i = 0; i < this.dates.length; i++) {
          formatDate.push(
            moment(this.dates[i]).format(this.getStandartFormatDate)
          );
        }

        post.append("tlc", this.getAuth.username);
        post.append("keperluan", values.keperluan);
        post.append("approval", values.approval);
        post.append("tgl_cuti[]", formatDate);

        if (this.mode === "Edit") {
          formEdit = {
            tlc: this.getAuth.username,
            keperluan: values.keperluan,
            approval: values.approval,
            tgl_cuti: formatDate,
            id_cuti: this.id_cuti
          };
        }

        axios({
          method: this.mode === "Create" ? "post" : "put",
          url: this.$serviceUrl + "cuti",
          processData: false,
          data: this.mode === "Create" ? post : formEdit,
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password
          },
          headers: {
            "Content-Type":
              this.mode === "Create"
                ? "multipart/form-data"
                : "application/json",
            "X-API-KEY": this.getAuth.apikey
          }
        })
          .then(response => {
            if (this.mode === "Edit") {
              this.$notification.success({
                message: "Sukses",
                description: "Data telah berhasil diubah!"
              });
            } else {
              this.$notification.success({
                message: "Sukses",
                description: "Data telah berhasil diproses!"
              });
            }
            this.loading = false;
            this.$router.go({ name: "landingCuti" });
            this.visible = false;
          })
          .catch(err => {
            if (err.response.data.message == "Jatah Cuti Anda Sudah Habis") {
              this.$notification.error({
                message: "Error",
                description:
                  "Jatah Cuti Sudah Habis, Tidak Dapat Melakukan Permohonan Cuti ... "
              });
            }

            this.loading = false;
            this.visible = false;
          });
      });
    },
    handleCancel() {
      this.visible = false;
      this.dates = [];
      this.id_cuti = "";
    },
    limaHari(date, days) {
      date = moment(date);
      while (days > 0) {
        date = date.add(1, "days");
        if (date.isoWeekday() !== 6 && date.isoWeekday() !== 7) {
          days -= 1;
        }
      }
      return date._d;
    }
    // disabledDate(current) {
    //   const weekdays = [0, 1, 2, 3, 4].map(date =>
    //     moment()
    //       .locale("id-ID")
    //       .weekday(date)
    //       .format(this.getDefaultDateFormat)
    //   );

    //   if (
    //     current < moment().endOf("day") ||
    //     current < this.limaHari(moment(), 5) ||
    //     this.workingDay.indexOf(current.days()) === -1
    //   ) {
    //     return true;
    //   } else {
    //     return false;
    //   }
    // }
  }
};
</script>

<style>
</style>